import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ChangePassword() {
  const { user, updateUser, logout } = useAuth();
  const nav = useNavigate();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Passwords do not match");
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      const updated = { ...user, must_change_password: false };
      updateUser(updated);
      toast.success("Password updated");
      nav(user.role === "super_admin" ? "/admin" : "/store");
    } catch (err) { toast.error(formatError(err)); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen paper-bg grid place-items-center p-6">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-sm p-8 space-y-5">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-orange-50 text-orange-600 grid place-items-center"><KeyRound className="w-5 h-5" /></div>
          <div>
            <h2 className="font-display text-xl font-bold">Change your password</h2>
            <p className="text-sm text-slate-500">Required on first login</p>
          </div>
        </div>
        <div className="space-y-2"><Label>Current password</Label><Input type="password" required value={cur} onChange={(e) => setCur(e.target.value)} data-testid="change-current" /></div>
        <div className="space-y-2"><Label>New password</Label><Input type="password" required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="change-new" /></div>
        <div className="space-y-2"><Label>Confirm new password</Label><Input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="change-confirm" /></div>
        <Button type="submit" disabled={loading} className="w-full bg-orange-500 hover:bg-orange-600 h-11" data-testid="change-submit">{loading ? "Updating…" : "Update password"}</Button>
        <button type="button" onClick={logout} className="w-full text-sm text-slate-500 hover:text-slate-700">Sign out</button>
      </form>
    </div>
  );
}
